import * as React from 'react';
import { Button, Col, Row } from 'reactstrap';
import { Svg } from 'src/components/shared/Svg';
import {
  IGlobalContextProps,
  withGlobalContext,
} from 'src/context/global.context';
import { IStep } from 'src/model';
import { endProject } from 'src/services';

interface IWorkspaceStepWorkspaceStepClosureProps {
  stepList: IStep[];
}

const WorkspaceStepClosure: React.SFC<
  IWorkspaceStepWorkspaceStepClosureProps & IGlobalContextProps
> = ({ stepList, context }) => {
  const handleClick = async (projectId: string) => {
    const newProject = await endProject(projectId);
    if (newProject) {
      context.updateProject(newProject);
    }
  };

  const { project, user } = context;
  const isActive = !!!stepList.filter(
    (step: IStep) => step.meta.status !== 'validated'
  ).length;
  const isEnded = project && project.meta.status === 'ended';
  const isClient = user && user.type === 'client';

  return (
    <Row className='pb-4' style={{ opacity: isActive ? 1 : 0.5 }}>
      <Col
        className='d-flex flex-column align-items-center position-relative'
        xs='2'
      >
        <Svg
          className='position-absolute mt-1'
          width={24}
          height={24}
          fill='white'
          src='racing-flag'
          style={{ zIndex: 10 }}
        />
        <Svg
          className='position-absolute'
          width={48}
          height={48}
          fill={isEnded ? 'primary' : isActive ? 'secondary' : 'dark'}
          opacity={isActive ? 1 : 0.25}
          src='step-bulle'
        />
      </Col>
      <Col xs='4' className='mt-2'>
        <span className={`d-block text-${isEnded ? 'primary' : 'dark'}`}>
          {isEnded ? 'Projet terminé' : 'Clôture'}
        </span>
      </Col>
      <Col xs='6' className='mt-2'>
        {isActive && isClient ? (
          isEnded ? null : (
            <Button
              className='text-uppercase text-white bg-success border-0'
              size='sm'
              onClick={() => project && handleClick(project._id)}
            >
              Terminer le projet
            </Button>
          )
        ) : null}
      </Col>
    </Row>
  );
};

export const WorkspaceStepClosureWithGlobalContext = withGlobalContext(
  WorkspaceStepClosure
);



// WEBPACK FOOTER //
// ./src/components/Project/ProjectWorkspace/WorkspaceStepList/WorkspaceStepClosure.tsx